export default {
      id: "hat-usage",
      viewBox: "0 0 640 384",
      url: "../../assets/" + "sprite.svg#hat-usage",
      toString: function () {
        return this.url;
      }
    }